import React from "react"
import { API_URL } from '../../Actions/Config'
import TourList from "./HomeTourList"
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"

function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        default:
            break;
    }
    return image
}


const HomeTourRow = (props) => {

    const options = {
        margin: 15,
        items: 4,
        loop: props.tours.length > 4,
        autoplay: false,
        dots: false,
        nav: true,
        navText: [
            '<span aria-label="Previous">&#8249;</span>',
            '<span aria-label="Next">&#8250;</span>'
        ]
    };

    return (
        <section className="gry-lit home-page">
            <div className="container">
                <div className="row special-tour">
                    <div className="col-lg-12">
                        <div className="man-tou-lis">
                            <div className="hed-sub">
                                <h4>{props.title}</h4>
                                {props.showMore != false ?
                                    <a href={props.showMore}>Show more</a> : null}
                                <div className="clear"></div>
                            </div>
                            <div className="to-lis">
                                <OwlCarousel className="owl-carousel owl-theme owl-tour" {...options} key={props.tours.length}>
                                    {props.tours.map((tour, index) => (<TourList
                                        {...props}
                                        key={index}
                                        url={getURL(tour)}
                                        bgImage={getBackgroudImage(tour)}
                                        tour={tour}
                                    />))}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeTourRow;
